export const OPEN_QUICK_INFO = "OPEN_QUICK_INFO";
export const CLOSE_QUICK_INFO = "CLOSE_QUICK_INFO";
